import { CardData, CardType } from "../constants/GlobalTypesAndEnumsAndConstants";

// ───────────────────────── after the first review ─────────────────────────

// The order a first set's questions came in after the first review before (getCardsForFirstDeckReview's sort)
const CARD_TYPE_ORDER_AFTER_FIRST_REVIEW: string[] = [
  CardType.USMLEStep1MCQ,
  CardType.RegularMultipleChoiceQuestion,
  CardType.TrueOrFalseQuestion,
  CardType.RegularFreeResponseQuestion,
];

function getCardTypePosition(card: CardData): number {
  const position = CARD_TYPE_ORDER_AFTER_FIRST_REVIEW.indexOf(card.card_type as string);
  return position === -1 ? CARD_TYPE_ORDER_AFTER_FIRST_REVIEW.length : position;
}

/**
 * The rest of the first set once its first review is done: the first review's questions as they were
 * answered, then the set's first free response question (the step after the first review, as before), then
 * every other question by type (multiple choice, true/false, free response, the rest). The review carries on
 * from the first question after the first review, whatever its length: nothing answered comes back, and
 * nothing is skipped.
 */
export function buildCardsAfterFirstReview({
  allCards,
  firstReviewCards,
}: {
  allCards: CardData[];
  firstReviewCards: CardData[];
}): CardData[] {
  const firstReviewCardIds = new Set(firstReviewCards.map((card) => card.id));
  const cardsNotYetAsked = allCards
    .filter((card) => card && !firstReviewCardIds.has(card.id))
    .map((card, position) => ({ card, position }))
    .sort(
      (first, second) =>
        getCardTypePosition(first.card) - getCardTypePosition(second.card) || first.position - second.position
    )
    .map(({ card }) => card);
  const firstFreeResponseCard = cardsNotYetAsked.find(
    (card) => card.card_type === CardType.RegularFreeResponseQuestion
  );
  const otherCards = cardsNotYetAsked.filter((card) => card !== firstFreeResponseCard);
  return [...firstReviewCards, ...(firstFreeResponseCard ? [firstFreeResponseCard] : []), ...otherCards];
}
